/**
 * Identity of a Patient report batch run (period, clients, options), used to
 * warn before starting a duplicate of a run that is still in progress. Bundled
 * into the server renderer, so the server stores exactly what the UI compares.
 */
export function batchRunFingerprint({ ymKeys, clientIds, includeAllReadings, saveToCharts }) {
  return [
    (ymKeys || []).join(','),
    [...(clientIds || [])].sort().join(','),
    includeAllReadings ? 1 : 0,
    saveToCharts ? 1 : 0,
  ].join('|');
}
